<script lang="ts">
  import { send } from '~/animations/crossfade.svelte';
  import type { Highlighted, Match } from '~/types';
  import { crossing } from '~/animations/crossfade.svelte';

  type Props = {
    xScale: (v: number) => number;
    yScale: (v: number) => number;
    width: number;
    height: number;
    match?: Match;
    highlighted: Highlighted;
  };

  const props: Props = $props();
</script>

{#each crossing.shadows as tile (tile.key)}
  <div
    class="shadow-container {props.highlighted[tile.key]}"
    style="
        width: {props.width}px;
        height: {props.height}px;
        transform: translate3d(
          {props.xScale(tile.coords![0] + 0.1)}px,
          {props.yScale(tile.coords![1] + 0.1)}px,
          0px
        );
      "
    out:send={{
      shadow: true,
      key: `${tile.key}-shadow`,
      scale: tile.scale,
      coords: tile.coords,
      index: tile.index,
      origin: [
        props.xScale(crossing.origin![0]),
        props.yScale(crossing.origin![1]),
      ],
    }}
  ></div>
{/each}

<style lang="scss">
  @use '~/theme/theme';
  .shadow-container {
    position: absolute;
    z-index: 400;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    // only visible through the fly-out animation (which starts at opacity 0), so a shadow never
    // flashes at full opacity between being mounted and starting to animate
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.1);
  }

  :global(html:not(.dark-mode)) .shadow-container {
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.8);
    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.4);
  }

  :global(html.dark-mode) .shadow-container {
    &.blue {
      @include theme.shadow-color(theme.$tile-blue-dark);
    }
    &.green {
      @include theme.shadow-color(theme.$tile-green-dark);
    }
    &.purple {
      @include theme.shadow-color(theme.$tile-purple-dark);
    }
    &.red {
      @include theme.shadow-color(theme.$tile-red-dark);
    }
    &.orange {
      @include theme.shadow-color(theme.$tile-orange-dark);
    }

    &.daily-vertical {
      @include theme.shadow-color(theme.$daily-vertical-dark);
    }
    &.daily-horizontal {
      @include theme.shadow-color(theme.$daily-horizontal-dark);
    }
  }
</style>
